import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { NxiNgCommonModule } from '@pershing/nxi-ng-common';
import { ModPreloginModule } from '@pershing/nxi-ng-mod';
import { NxiModernNavigationModule } from '@pershing/nxi-ng-modern-navigation';
import { PershingF2Module } from '@pershing/pershing-f2';
import { BiometricAuthComponent } from './components/biometric-auth.component';
import { NxiF2Common } from './components/f2.common';
import { NxiF2Title } from './components/f2.title';
import { GoogleAnalyticsComponent } from './components/googleAnalytics.component';
import { ModernThemeFooterComponent } from './components/modern-theme-footer.component';
import { NxiModernThemeHeaderComponent } from './components/modern-theme-header.component';
import { NxiF2Component } from './components/nxi-f2.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { SessionTimeoutComponent } from './components/sessiontimeout-warning.component';
import { NxiCookieService } from './services/NXI-Cookie.service';
import { NxiRestService } from './services/NXI-Rest.service';
import { PortalComponentService } from './services/portal-component.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { PershingCoreRootModule } from '@pershing/pershing-core';
import { PershingCommonModule } from '@pershing/pershing-common';
import { PershingGridHeaderComponent } from './components/pershing-grid-header/pershing-grid-header.component';
import { ViewApplication } from './services/view-application.service';
import { NxiGridHeaderComponent } from './components/nxi-grid-header/nxi-grid-header.component';
import { RouterModule } from '@angular/router';
import { MCVHeaderComponent } from './components/mcv-banner/mcv-header.component';
import { BackNavigationComponent } from './components/back-navigation/back-navigation.component';


const NXI_PORTAL_COMPONENTS = [
  NxiF2Component,
  NxiF2Title,
  NxiF2Common,
  SessionTimeoutComponent,
  GoogleAnalyticsComponent,
  BiometricAuthComponent,
  ProfileMenuComponent,
  NxiModernThemeHeaderComponent,
  ModernThemeFooterComponent,
  PershingGridHeaderComponent,
  NxiGridHeaderComponent,
  MCVHeaderComponent,
  BackNavigationComponent
];

@NgModule({
  imports: [
    NxiNgCommonModule,
    ModPreloginModule,
    PershingF2Module,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatMenuModule,
    MatDividerModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatSelectModule,
    PortalModule,
    OverlayModule,
    MatProgressBarModule,
    NxiModernNavigationModule,
    PershingCoreRootModule,
    PershingCommonModule,
    FormsModule,
    CommonModule,
    RouterModule,
  ],
  declarations: [...NXI_PORTAL_COMPONENTS],
  exports: [...NXI_PORTAL_COMPONENTS],
  providers: [
    PortalComponentService,
    NxiRestService,
    NxiCookieService,
    ViewApplication,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PortalComponentsModule {}
